import styled from '@emotion/styled';

export const SContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
`;

export const SCounterpartyLogo = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 500;
  color: #FFF;
  background: ${(props: { backgroundColor: string }): string => props.backgroundColor};
  text-transform: uppercase;
`;

export const SCounterpartyName = styled.div`
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  color: rgba(0, 0, 0, 0.85);
`;
